import React, { useMemo } from 'react';

import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';

import { USER_CONFIG, BATCHES_CONFIG } from 'constants/api';

import { Table, Filters, TableCell, ActiveStatusIndicator } from 'comps';
import styled, { keyframes } from 'styled-components';
import { Row, Separator } from '@cuemath/comps';
import Pagination from 'modules/list/pagination';
import { TableRow, Dropdown } from 'semantic-ui-react';

import ViewIcon from 'img/view.png';
import EditIcon from 'img/edit.png';
import { FORM_ACTIONS } from 'constants/form';
import { IconButton } from 'modules/list';

import { getOptions } from 'modules/form';

const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Root = styled.div`
  padding: 24px 16px;
  animation: ${FadeIn} 0.5s ease-in-out;
`;

const PaginationWrapper = styled(Row)`
  height: 42px;
`;

const StyledTableCell = styled(TableCell)`
  cursor: pointer;
`;

const TableWrapper = styled.div`
  margin-top: 24px;
`;

const TeacherList = props => {
  const {
    teachers,
    openTeacherForm,
    onViewSlots,
    page,
    onPageChange,
    onFilter,
    userConfig,
    programs,
    isProcessing,
    queryCount,
    filterParam
  } = props;

  let stateOptions = [];

  if (userConfig && programs) {
    stateOptions = getOptions({ field: 'teacherState', userConfig, programs });
  }

  const addKeys = options => {
    const temp = options?.map(item => {
      const { label, value } = item;
      return { text: label, key: value, value };
    });

    return temp;
  };

  const handleAddStateFilter = (key, data) => {
    const { value } = data || {};

    onFilter([...(filterParam ?? []), { id: 'state', value }]);
  };


  const handleFilterChange = data => {
    if (data?.includes('Test accounts')) {
      onFilter([{ id: 'is_demo', value: true }]);
    } else {
      onFilter([]);
    }
  };

  const stateFilterValue = useMemo(() => filterParam?.find(({id}) => id === 'state')?.value ?? [], [filterParam])
  
  return (
    <Root id="manual-portal-root">
      <TableWrapper>
        <Filters filters={['Test accounts']} handleFilterChange={handleFilterChange} />
        <Table
          headerCell={[
            { title: 'View' },
            { title: 'Edit' },
            { title: 'Teacher name' },
            {
              title: 'Teacher state',
              filterApplied: stateOptions?.length,
              filterComponent: (
                <Dropdown
                  clearable
                  fluid
                  multiple
                  onChange={handleAddStateFilter}
                  options={addKeys(stateOptions)}
                  placeholder="Select State"
                  search
                  selection
                  value={stateFilterValue}
                />
              ),
              showFilters: true,
            },
            { title: 'Teacher plus cred' },
            { title: 'Teacher slots' },
          ]}
          dataLength={teachers?.length}
          havePagination
          showInfo={false}
          showLoader={isProcessing}
        >
          {teachers.map(teacher => {
            const { name, state, is_plus: isPlus, id } = teacher || {};
            return (
              <TableRow key={id}>
                <StyledTableCell
                  width={1}
                  onClick={() =>
                    openTeacherForm({
                      formType: FORM_ACTIONS.VIEW,
                      data: teacher,
                    })
                  }
                >
                  <IconButton icon={ViewIcon} />
                </StyledTableCell>

                <StyledTableCell
                  width={1}
                  onClick={() =>
                    openTeacherForm({
                      formType: FORM_ACTIONS.EDIT,
                      data: teacher,
                    })
                  }
                >
                  <IconButton icon={EditIcon} />
                </StyledTableCell>
                <StyledTableCell
                  width={5}
                  onClick={() => {
                    if (!id) return () => {};
                    return window.open(`/users/teachers/${id}`, '_blank');
                  }}
                >
                  {name?.trim() || '-'}
                </StyledTableCell>
                <TableCell width={3}>
                  <ActiveStatusIndicator status={state} />
                </TableCell>

                <TableCell width={4}>{isPlus ? 'PLUS' : 'NOT PLUS'}</TableCell>
                <StyledTableCell width={4} onClick={() => onViewSlots(teacher)}>
                  See Slots
                </StyledTableCell>
              </TableRow>
            );
          })}
        </Table>
      </TableWrapper>
      <Separator transparent height={8} />
      <PaginationWrapper justifyContent="center" alignItems="center">
        {teachers && (
          <Pagination
            page={page}
            perPage={20}
            count={queryCount}
            onPageChange={onPageChange}
            shouldShowNewUi
          />
        )}
      </PaginationWrapper>
    </Root>
  );
};

export default connect(
  ({ configs, programs }) => ({
    userConfig: store.get(configs, USER_CONFIG),
    batchConfig: store.get(configs, BATCHES_CONFIG),
    programs: store.getAll(programs),
  }),
  null,
)(TeacherList);
